<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('common.tips')" center :width="lang==='en'?'600px':'500px'"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">

      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-ct">
          <div class="f-l">{{$t('login.clearSellout')}}</div>
        </div>
      </div>

      <div class="dialog-btm w100p df-c-sa">
        <div class="whitebtn" @click="clearSellout(true)">{{$t('login.clearSelloutOk')}}</div>
        <div class="themebtn" @click="close">{{$t('login.clearSelloutNot')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogSellout',
  data() {
    return {
      isShowDialog: false,
    }
  },
  inject: ['itemsSellOutSearch'],
  methods: {
    open() {
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
    },
    
    // 查询当前商鋪是否有售罄
    checkSellOut() {
      this.$api.sellOut_search({ id: this.currentShopId }).then(res => {
        if (res.status == 0) {
          let _R = res.data
          console.log(`%c是否有售罄:`, 'color: #f00;', _R)
          if (_R) {
            // 有售罄
            this.open()
          }
        } else { this._status(res) }
      })
    },
    // 恢復售罄
    clearSellout(selloutStatus) {
      if (selloutStatus) {
        this.$api.sellOut_clear({ id: this.currentShopId }).then(res => {
          if (res.status == 0) {
            this.itemsSellOutSearch()
            this.close()
          } else { this._status(res) }
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.dialog-square /deep/.el-dialog{min-height: 300px;} // 默認500px
.mydialog{
  padding: 80px 0;
}
</style>